export default "__VITE_ASSET__DtcTNEWB__"